import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    padding: 0,

    '& .slot-details': {
      '&-content': {
        padding: 0,
        maxHeight: theme.spacing(53),
      },
      '&-header': {
        display: 'flex',
        padding: theme.spacing(6, 3, 3),

        '&-icon': {
          color: theme.palette.custom.feedback.positive,
          fontSize: theme.spacing(6),
          marginRight: theme.spacing(2),
        },
        '&-infos': {
          flexDirection: 'column',
          flexGrow: 1,
        },
        '&-label': {
          color: theme.palette.text.hint,
        },
      },
      '&-listInfos': {
        '&-title': {
          padding: theme.spacing(1, 3),
          color: theme.palette.text.hint,
          position: 'sticky',
          top: 0,
          background: theme.palette.custom.background.area,
          display: 'flex',
          zIndex: '1',
        },

        '&-container': {
          listStyle: 'none',
          padding: 0,
        },
        '&-item': {
          padding: theme.spacing(1, 3),
          display: 'flex',
        },
        '&-label': {
          minWidth: '30%',
          color: theme.palette.text.hint,
        },
        '&-value': {
          '&-container': {
            minWidth: '70%',
            paddingLeft: theme.spacing(1),
            display: 'flex',
            flexDirection: 'column',
          },
          '&-primary': {
            fontWeight: 'bold',
          },
          '&-secondary': {
            color: theme.palette.text.hint,
          },
          '&-link': {
            fontWeight: 'bold',
            wordBreak: 'break-all',
          },
        },
        '&-status': {
          padding: theme.spacing(0, 1),
          borderRadius: theme.shape.borderRadius,
          height: theme.spacing(5 / 2),
          lineHeight: 1,
          display: 'inline-flex',
          alignSelf: 'flex-start',
          alignItems: 'center',
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.getContrastText(theme.palette.primary.main),

          '&-icon': {
            fontSize: theme.spacing(2),
            marginRight: theme.spacing(1),
          },

          '&.concluded': {
            backgroundColor: theme.palette.custom.feedback.positive,
            color: theme.palette.getContrastText(
              theme.palette.custom.feedback.positive,
            ),
          },
          '&.info-absence': {
            backgroundColor: theme.palette.custom.feedback.warning,
            color: theme.palette.getContrastText(
              theme.palette.custom.feedback.warning,
            ),
          },
          '&.absent': {
            backgroundColor: theme.palette.custom.feedback.negative,
            color: theme.palette.getContrastText(
              theme.palette.custom.feedback.negative,
            ),
          },
          '&.canceled': {
            backgroundColor: theme.palette.grey[300],
            color: theme.palette.getContrastText(theme.palette.grey[300]),
          },
        },
      },
    },
  },
  paper: {
    width: '100%',
  },
}));

export default styles;
